
import { computed, defineComponent, inject, ref } from 'vue';
import { DISPLAY_COUNTS, ISignupFormState, MARKETS } from '../signupFlow';
import { ISignupService } from '../signupService';
import {
    PhArrowLeft,
    PhArrowRight,
    PhArrowSquareOut,
    PhBuildings,
    PhCaretDown
} from '@phosphor-icons/vue';

export default defineComponent({
    name: 'StepOrganization',
    components: { PhArrowLeft, PhArrowRight, PhArrowSquareOut, PhBuildings, PhCaretDown },
    emits: ['next', 'back'],
    setup(props, { emit }) {
        const form = inject('signupForm') as ISignupFormState;
        const service = inject('signupService') as ISignupService;
        const showErrors = ref(false);
        const submitting = ref(false);
        const errorMessage = ref('');

        const isHome = computed(() => form.market === 'Home');
        // FLOCK-6778: required again; whitespace alone does not count.
        const plannedUseMissing = computed(() => !(form.plannedUse || '').trim());
        const isValid = computed(
            () => !!form.orgName && !!form.market && !!form.numDisplays && !plannedUseMissing.value
        );

        // Step-2 complete is the org-creation seam: registration (org + user +
        // HubSpot capture) fires here, and the account step shows on success.
        async function handleNext() {
            if (!isValid.value) {
                showErrors.value = true;
                return;
            }
            submitting.value = true;
            errorMessage.value = '';
            const result = await service.submitRegistration(form);
            submitting.value = false;
            if (result.success) {
                emit('next');
            } else {
                errorMessage.value = result.reason || 'There was an error during signup. Please try again.';
            }
        }

        return {
            form,
            showErrors,
            plannedUseMissing,
            submitting,
            errorMessage,
            isHome,
            handleNext,
            markets: MARKETS,
            displayCounts: DISPLAY_COUNTS
        };
    }
});
